<template>
    <CardDropdownSm :item="socialData">
        <template #icon>
            <component :is="socialData.icon" class="flex-shrink-0 h-5 ct-fg-4" />
        </template>
        <template #extra>
            <FormToggleSm
                :modelValue="!!social.enabled"
                @update:modelValue="$emit('toggleEnabled')"
            />
        </template>
    </CardDropdownSm>
</template>

<script>
import { PencilSquareIcon, CopyDocumentIcon, TrashBinIcon } from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";
import { FormToggleSm } from "@easy/ui/forms";

export default {
    props: {
        social: {
            type: Object,
            required: true,
        },
    },
    emits: ["edit", "delete", "duplicate", "toggleEnabled"],
    components: {
        PencilSquareIcon,
        CopyDocumentIcon,
        CardDropdownSm,
        FormToggleSm,
        TrashBinIcon,
    },
    computed: {
        socialData() {
            return {
                title: this.social.title,
                icon: this.social.icon,
                enabled: this.social.enabled,
                url: this.social.url,
                actions: [
                    { label: "Edit", icon: PencilSquareIcon, handler: () => this.$emit("edit") },
                    {
                        label: "Hide",
                        icon: CopyDocumentIcon,
                        handler: () => this.$emit("toggleEnabled"),
                    },
                    this.social.predefined ? {} : { isDivider: true },
                    this.social.predefined
                        ? {}
                        : {
                              label: "Delete",
                              icon: TrashBinIcon,
                              isDanger: true,
                              handler: () => this.$emit("delete"),
                          },
                ],
            };
        },
    },
};
</script>
